<template>
  <div>
    <div class="row row-cols-4">
      <div class="col" v-for="post in posts" :key="post.id">
        <video-card :post="post" />
      </div>
    </div>

    <div class="title-section commentsSect" @click="getVideos" v-show="enabled">
      <h3 class="heading-title-sect text-center">
        <span>MÁS {{ sName }}</span>
      </h3>
    </div>
  </div>
</template>

<script>
import VideoCard from "./../video-card/VideoCard.vue";
import axios from "axios";
import epica from "../../../features/epica";
export default {
  components: { VideoCard },
  props: {
    showName: String,
    bannedIds: Array,
    initOffset: Number,
    sName: String,
    total: Number,
  },
  created: function () {
    this.offset = this.initOffset;
    this.take = 8;
    this.tfNews = {};
  },
  updated: function () {
    epica();
    document.dispatchEvent(lrLoad);
  },
  methods: {
    getVideos: function () {
      this.loading = true;
      var _self = this;
      axios
        .get("/api/pager/videos", {
          params: {
            showName: this.showName,
            take: this.take,
            offset: this.offset,
            bIds: this.bannedIds,
          },
        })
        .then(function (d) {
          _self.loading = false;
          _self.posts = _self.posts.concat(d.data);
          _self.offset += _self.take;
        });
    },
  },
  computed: {
    enabled: function () {
      return this.offset < this.total && !this.loading;
    },
  },
  data: function () {
    return {
      posts: [],
      loading: false,
    };
  },
};
</script>
